import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState()
  ],
  state: {
  	order: {},
    token: false,
    stylist: {},
    test_stylist: 0,
    repositories: {},
    user_roles: [],
    interface_message: {},
    isLoading: false,
    messages: [{}],
    low_data: false,
    sidebar: false,
    sidebar_pins: [],
    userCurrencyId: 1,
    noti_sent_time: 0,
    stylingBox: {},
    stylingCategories: [],
    stylingProductCategories: [],
    preshippingStylingFeedback: [],
    letterText: { stylingBoxNumber: 1,  stylingSingleComment: '' }
  },
  getters: {
    isSidebarOpen: state => state.sidebar,
    isLowDataMode: state => state.low_data,
    getSidebarPins: state => state.sidebar_pins,
    getToken: state => state.token,
    getStylist: state => state.stylist,
    getTestStylist: state => state.test_stylist,
    getStylists: state => state.repositories.users ? state.repositories.users.filter(record => record.roles.indexOf('stylist') >= 0) : [],
    getStylistLocaleId: state => state.stylist.locale_id,
    getStylistUserRoles: state => state.user_roles,
    getInterfaceMessage: state => state.interface_message,

    getRepositories: state => state.repositories,
    getWorkers: state => state.repositories.workers,
    getTags: state => state.repositories.tags,
    getCountries: state => state.repositories.countries,
    getLocales: state => state.repositories.locales,
    getCurrencies: state => state.repositories.currencies,
    getUserRoles: state => state.repositories.user_roles,
    getUsers: state => state.repositories.users,
    isLoading: state => state.isLoading,
    userCurrencyId: state => state.userCurrencyId,
    getMessages: state => state.messages,
    getNotiSentTime: state => state.noti_sent_time,
    getStylingBox: state => state.stylingBox,
    getStylingCategories: state => state.stylingCategories,
    getStylingProductCategories: state => state.stylingProductCategories,
    getPreshippingStylingFeedback: state => state.preshippingStylingFeedback,
    getLetterText: state => state.letterText
  },
  mutations: {
    setSidebarPins: (state, pins) => state.sidebar_pins = pins,
    setSidebarOpen: (state, open) => state.sidebar = open,
    setLowDataMode: (state, mode) => state.low_data = mode,
    addMessage: (state, message) => state.messages = [message],
    setInterfaceMessage: (state, message) => state.interface_message = message,
    setOrder: (state, order) => state.order = order,
    setToken: (state, token) => state.token = token,
    setStylist: (state, stylist) => state.stylist = stylist,
    setTestStylist: (state, test_stylist) => state.test_stylist = test_stylist,
    setRepositories: (state, repositories) => state.repositories = repositories,
    setUserRoles: (state, user_roles) => state.user_roles = user_roles,
    setLoading: (state, value) => state.isLoading = value,
    setStylistColor: (state, color) => state.stylist.color = color,
    setUserCurrencyId: (state, id) => state.userCurrencyId = id,
    setNotiSentTime: (state, time) => state.noti_sent_time = time,
    setStylingBox: (state, newBox) => state.stylingBox  = newBox,
    setStylingCategories: (state, categories) => state.stylingCategories  = categories,
    setStylingProductCategories: (state, productCategories) => state.stylingProductCategories  = productCategories,
    setPreshippingStylingFeedback: (state, stylingFeedback) => state.preshippingStylingFeedback  = stylingFeedback,
    setLetterText: (state, letterTextValues) => state.letterText  = letterTextValues
  },
  actions: {
    loadRepositories (context) {
      Vue.$api.get('/dashboard/repositories', {}, {
        callback: data => context.commit('setRepositories', data)
      })
    }
  }
})
